module.exports = __webpack_public_path__ + "img/space9.013b49ff.jpg";